define(function() {
  return function(app) {

    app.factory('modalFactory', [function($) {
      return {
        modals: [],
        overlay: {
          active: false
        },
        addModal: function() {
          var id = this.modals.length;
          var setup = {
            id: id,
            active: false
          };
          this.modals[id] = setup;
          return this.modals[id];
        },
        open: function(id) {
          angular.forEach(this.modals, function(item, key) {
            item.active = (item.id === id);
          });
          this.updateOverlay();
        },
        close: function() {
          angular.forEach(this.modals, function(item, key) {
            item.active = false;
          });
          this.updateOverlay();
        },
        updateOverlay: function() {
          var hasactive = false;
          angular.forEach(this.modals, function(item, key) {
            if(item.active == true) hasactive = true;
          });
          this.overlay.active = hasactive;
          return this.overlay.active;
        }
      }//end return obj
  	}]); //END FACTORY

    app.directive('modalTrigger', ['modalFactory', function($modalFactory) {
      return {
        restrict: "A",
        scope: true,
        bindToController: {
        },
        controllerAs: 'ctrl',
        controller: ['$scope', function ($scope) {
          $scope.modal = $modalFactory.addModal();

          $scope.openModal = function(event) {
            //"event" automatically shared by angular, no need to add to parameters
            if(event) event.preventDefault();
            if($scope.modal.active == true) return;
            $modalFactory.open($scope.modal.id);
          }
          $scope.closeModal = function (event) {
            //"event" automatically shared by angular, no need to add to parameters
            if(event) event.preventDefault();
            $modalFactory.close();
          }
        }]
      }//end return obj
  	}]); //END FACTORY

    app.directive('modalOverlay', ['modalFactory', function($modalFactory) {
      return {
        restrict: "A",
        scope: true,
        bindToController: {},
        controllerAs: 'ctrl',
        controller: ['$scope', function ($scope) {
          $scope.overlay = $modalFactory.overlay;

          $scope.closeModal = function (event) {
            if(event) event.preventDefault();
            $modalFactory.close();
          }

          $scope.$watch('overlay.active', function(data){
            //if(data) console.log('modal active');
          }, true);
        }]
      }//end return obj
  	}]); //END FACTORY
  }
});
